import React, {useEffect, useState} from "react";
import FetchUtil from "../../util/FetchUtil";
import ConfigUtil from "../../util/ConfigUtil";
import DHSelectionComponent from "./DHSeclectionCompontent";

export function SelectTeamComponent({teamid, onChange, onError}) {

    const [teams, setTeams] = useState([]);
    const [teamsLoaded, setTeamsLoaded] = useState(false);

    useEffect(() => {
        if( !teamsLoaded ) {
            loadTeams();
            setTeamsLoaded(true);
        }
    });

    const loadTeams = () => {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.settings + "/team",
            json => {
                setTeams(json);
            },
            responseNotOk => {
                onError("Fehler beim Laden der Mannschaften: " + responseNotOk.message);
            },
            error => {
                propsonError("Fehler beim Laden der Mannschaften: " + error.message);
            })
    }

    const getTeams = () => {
        let returnValue = [];
        returnValue.push({name: 'Auswahl löschen', code: undefined});
        for (const team of teams) {
            returnValue.push({name: team.bezeichnung, code: team.id });
        }
        return returnValue;
    }

    return <DHSelectionComponent value={teamid} onChange={(id) => onChange(id)} values={getTeams()} title="Teams"/>
}